export default __webpack_public_path__ + "static/media/1017.d1efb1ec.png";